<div ngClass.gt-md="container" id="productDetails">
  <div class="bg-color">

    <calsoft-product-mobile-image [bigImage]="bigImage" [commonImageApi]="commonImageApi" [image]="image"
      [productDetailHeight]="productDetailHeight" [productDetailWidth]="productDetailWidth"
      [productDetailWidthMobile]="productDetailWidthMobile" [productDetailHeightMobile]="productDetailHeightMobile"
      [name]="name" [imageList]="imageList"></calsoft-product-mobile-image>


    <calsoft-product-icon fxHide fxShow.lt-md [showGenuineProductIcon]="showGenuineProductIcon"
      [genuineProductText]="genuineProductText" [deliveryTime]="deliveryTime"
      [deliveryDoorStepText]="deliveryDoorStepText" [ColdChain]="ColdChain" [showTimeIcon]="showTimeIcon"
      [deliveryDoorStepIcon]="deliveryDoorStepIcon" [displayColdChain]="displayColdChain"></calsoft-product-icon>


    <div class="prod" fxLayout="row" fxLayout.sm="column" class="pd padding-10" fxLayoutGap="2px">
      <div fxHide fxShow.gt-sm [fxFlex]="productDetailImageWidth" class="product-details">
        <calsoft-product-image3 [name]="name" [configProductSelected]="configProductSelected" [product]="product"
          [imageList]="imageList" [image]="image" [productDetailHeight]="productDetailHeight"
          [productDetailWidth]="productDetailWidth" [productDetailWidthMobile]="productDetailWidthMobile"
          [productDetailPageSubimageHeight]="productDetailPageSubimageHeight"
          [productDetailHeightMobile]="productDetailHeightMobile" [productIdAddedInCart]="productIdAddedInCart"
          [data]="data" [zoomImage]="zoomImage" (mouseMoveEvent)="onMouseMove($event)"
          (leaveMoveEvent)="onMouseLeave($event)" [productDetailImageWidth]="productDetailImageWidth"
          [productzoom]="productzoom" [imageList]="imageList" [showGenuineProductIcon]="showGenuineProductIcon"
          [genuineProductText]="genuineProductText" [deliveryTime]="deliveryTime"
          [deliveryDoorStepText]="deliveryDoorStepText" [ColdChain]="ColdChain" [showTimeIcon]="showTimeIcon"
          [deliveryDoorStepIcon]="deliveryDoorStepIcon" (zoomImageEvent)="setZoomImage($event)"
          [displayColdChain]="displayColdChain"></calsoft-product-image3>
      </div>
      <div fxFlex="100" fxFlex.md="100" fxFlex.gt-sm="50" style="border-radius: 14px;" class="product-details1 border"
        ngClass.gt-md="padding-20">
        <div #zoomViewer fxShow="false" fxShow.gt-sm>
          <mat-card *ngIf="zoomImage" class="zoom-viewer mat-elevation-z0"
            [ngStyle]="{'background-image': 'url(' + zoomImage + ')'}">
          </mat-card>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div *ngIf="name.length > 0">
            <calsoft-translator [translateValue]="name" [type]="'productsdetails'"></calsoft-translator>
            <div fxLayout="row" fxLayoutGap="5px">
              <div *ngFor="let row of customField3 | keyvalue; let i = index; let last = last">
                <p>{{ row.value }}<span *ngIf="!last">.</span></p>
              </div>
            </div>
          </div>

          <div fxLayout="row" class="wishMobile" fxLayoutAlign="end center">
            <calsoft-controls [data]="data" fxLayoutGap="10px" [coversionTrackingIdGa]="coversionTrackingIdGa"
              fxLayoutAlign="end center" [product]="configProductSelected" [configproduct]="product"
              [buttonArray]="buttonArray" [type]="'wishonly'">
            </calsoft-controls>
          </div>
        </div>



        <calsoft-star-rate [averageRating]="averageRating" [calculateAvgRating]="calculateAvgRating">
        </calsoft-star-rate>



        <ng-container style="margin-left: 5px;" *ngIf="!showNewConfig; else newconfig">
          <div fxLayout="row" style="margin-left: 5px;">
            <ng-container *ngIf="configattributeType==1;">
              <div [style.padding-top]="configurationDropDownList.size==0 ? '0px' : '10px'" fxLayout="row"
                *ngFor="let item of configurationDropDownList | keyvalue">
                <mat-form-field appearance="outline" fxFlex>
                  <mat-label>
                    {{item.key.replace('_', ' ') }}
                  </mat-label>
                  <mat-select (selectionChange)="getConfigProductId($event.value,i)" [disableOptionCentering]="true"
                    [formControl]="dropDownValue">
                    <mat-option [value]="object" *ngFor="let object of item.value;let i=index ">
                      {{object |splitbyHash}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </ng-container>


            <ng-container *ngIf="configattributeType==2;">

              <span class="mtb10">

                <div class="size,mtb10" fxLayoutGap="5px" *ngFor="let object  of configurationDropDownList | keyvalue">
                  <span>{{object.key.replace('_', ' ') }}:</span>
                  <div fxFlex fxLayout="row">
                    <div class="brStyle" fxLayout="row wrap" fxLayoutGap="5px">
                      <div fxflex="33.33" *ngFor="let size of object.value;let i=index;" class="imagesProduct"
                        [class.highlightedImage]="i == firstIndex" fxLayout="column" fxLayoutAlign="center center">
                        <div class="imagesPro padding-3">
                          <a (click)="getConfigProductId(size,i)">


                            <img [alt]="name" class="imgH" [src]="getImageproductIdOld(size)"
                              onerror="this.src='assets/images/products/noImage/no-image.png';">
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </span>




            </ng-container>

            <ng-container *ngIf="configattributeType==4;">
              <span class="mtb10" *ngFor="let item of configurationDropDownList | keyvalue">

                <div class="size,mtb10" fxLayoutGap="5px">
                  <span class="fw-500"> {{item.key.replace('_', ' ') }}:</span>
                  <button [class.highlightedImage]="firstIndex ==i" fxLayoutGap="5px" mat-raised-button
                    (click)="getConfigProductId(object,i)" *ngFor="let object of item.value;let i=index;"
                    [style.background]="object |splitbyHash">&nbsp;</button>
                </div>
              </span>

            </ng-container>

            <ng-container *ngIf="configattributeType==3;">
              <span class="mtb10" *ngFor="let item of configurationDropDownList | keyvalue">

                <div class="size mtb10" fxLayoutGap="5px">
                  <span class="fw-500 mtb10"> {{item.key.replace('_', ' ') }}:&nbsp;</span>
                  <button [class.highlightedImage]="firstIndex ==i" fxLayoutGap="5px" mat-raised-button
                    (click)="getConfigProductId(object,i)" *ngFor="let object of item.value;let i=index;">
                    {{object |splitbyHash}}
                  </button>
                </div>
              </span>

            </ng-container>

          </div>
        </ng-container>


        <ng-template #newconfig>
          <div fxLayout="row" style="margin-left: 5px;" fxLayoutGap="5px">
            <ng-container>

              <ng-container *ngIf="configurationDropDownList[0].configAttributeType==1;
     ">


                <mat-form-field appearance="outline" fxFlex>
                  <mat-label>
                    {{configurationDropDownList[0].key}}
                  </mat-label>


                  <mat-select [(ngModel)]="configurationDropDownList[firstIndex].value" [disableOptionCentering]="true">
                    <mat-option (onSelectionChange)="getConfigProductIdNew($event,i,item,'firstIndex')"
                      [value]="item.value" *ngFor="let item of configurationDropDownList;let i=index;">
                      {{item.value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

              </ng-container>


              <ng-container *ngIf="configurationDropDownList[0].configAttributeType==4;">

                <span class="mtb10">

                  <div class="size,mtb10" fxLayoutGap="5px">
                    <span class="fw-500">{{configurationDropDownList[0].key}}:</span>
                    <button [class.highlightedImage]="i == firstIndex" fxLayoutGap="5px" mat-raised-button
                      (click)="getConfigProductIdButton(i,'firstIndex')"
                      *ngFor="let size of configurationDropDownList;let i=index;"
                      [style.background]="size.value">&nbsp;</button>
                  </div>
                </span>

              </ng-container>

              <ng-container *ngIf="configurationDropDownList[0].configAttributeType==5;">

                <span class="mtb10">

                  <div class="size,mtb10" fxLayoutGap="5px">
                    <span class="fw-500">{{configurationDropDownList[0].key}}:</span>
                    <button fxLayoutGap="5px" mat-mini-fab (click)="getConfigProductIdButton(i,'firstIndex')"
                      *ngFor="let size of configurationDropDownList;let i=index;" [style.background]="size.value">
                      <mat-icon *ngIf="i == firstIndex">done</mat-icon>
                    </button>
                  </div>
                </span>

              </ng-container>

              <ng-container *ngIf="configurationDropDownList[0].configAttributeType==2;">
                <span class="mtb10">

                  <div class="size,mtb10" fxLayoutGap="5px">
                    <span>{{configurationDropDownList[0].key}}:</span>
                    <div fxFlex fxLayout="row">
                      <div class="brStyle" fxLayout="row wrap" fxLayoutGap="5px">
                        <div fxflex="33.33" *ngFor="let size of configurationDropDownList;let i=index;"
                          class="imagesProduct" [class.highlightedImage]="i == firstIndex" fxLayout="column"
                          fxLayoutAlign="center center">
                          <div class="imagesPro padding-3">
                            <a (click)="getConfigProductIdButton(i,'firstIndex')">


                              <img [alt]="name" class="imgH" [src]="getImageproductId(size.productId)"
                                onerror="this.src='assets/images/products/noImage/no-image.png';">
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </span>

              </ng-container>



              <ng-container *ngIf="configurationDropDownList[0].configAttributeType==3;">
                <span class="mtb10">

                  <div class="size,mtb10" fxLayoutGap="5px">
                    <span>{{configurationDropDownList[0].key}}:</span>

                    <button fxLayoutGap="5px" mat-raised-button (click)="getConfigProductIdButton(i,'firstIndex')"
                      [class.highlightedImage]="firstIndex ==i "
                      *ngFor="let size of configurationDropDownList;let i=index;">

                      {{size.value}}</button>
                  </div>
                </span>

              </ng-container>


            </ng-container>
          </div>
          <div fxLayout="row" style="margin-left: 5px;">
            <ng-container fxLayout="row">
              <ng-container *ngIf="configurationDropDownList[0]
    ['recursuive'][0].configAttributeType==1;">

                <mat-form-field appearance="outline" fxFlex>
                  <mat-label>
                    {{configurationDropDownList[0]
                    ['recursuive'][0].key}}
                  </mat-label>
                  <mat-select [(ngModel)]="configurationDropDownList[firstIndex]
      .recursuive[secondIndex].value" [disableOptionCentering]="true">
                    <mat-option (onSelectionChange)="getConfigProductIdNew($event,j,item1,'secondIndex')"
                      [value]="item1.value" *ngFor="let item1 of configurationDropDownList[firstIndex]
['recursuive'];let j=index;">
                      {{item1.value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>


              <ng-container *ngIf="configurationDropDownList[0]
   ['recursuive'][0].configAttributeType==2;">
                <span class="mtb10">

                  <div class="size,mtb10" fxLayoutGap="5px">
                    <span>{{configurationDropDownList[0]
                      ['recursuive'][0].key}}:</span>
                    <div fxFlex fxLayout="row">
                      <div class="brStyle" fxLayout="row wrap" fxLayoutGap="5px">
                        <div fxflex="33.33" *ngFor="let size of  configurationDropDownList[firstIndex]
              ['recursuive'];let j=index;" class="imagesProduct" [class.highlightedImage]="secondIndex ==j"
                          fxLayout="column" fxLayoutAlign="center center">
                          <div class="imagesPro padding-3">

                            <a (click)="getConfigProductIdButton(j,'secondIndex')">

                              <img [alt]="name" class="imgH" [src]="getImageproductId(size.productId)"
                                onerror="this.src='assets/images/products/noImage/no-image.png';">
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </span>

              </ng-container>

              <ng-container *ngIf="configurationDropDownList[0]
  ['recursuive'][0].configAttributeType==4;">

                <span class="mtb10">

                  <div class="size,mtb10" fxLayoutGap="5px">
                    <span class="fw-500"> {{configurationDropDownList[0]
                      ['recursuive'][0].key}}:</span>
                    <button [class.highlightedImage]="secondIndex ==j" fxLayoutGap="5px" mat-raised-button
                      (click)="getConfigProductIdButton(j,'secondIndex')" *ngFor="let size of configurationDropDownList[firstIndex]
      ['recursuive'];let j=index; " [style.background]="size.value">&nbsp;</button>
                  </div>
                </span>

              </ng-container>

              <ng-container *ngIf="configurationDropDownList[0]
  ['recursuive'][0].configAttributeType==5;">

                <span class="mtb10">

                  <div fxLayoutGap="5px">
                    <span> {{configurationDropDownList[0]
                      ['recursuive'][0].key}}:</span>
                    <button [class.highlightedImage]="secondIndex ==j" mat-mini-fab
                      (click)="getConfigProductIdButton(j,'secondIndex')" *ngFor="let size of configurationDropDownList[firstIndex]
      ['recursuive'];let j=index; " [style.background]="size.value">
                      &nbsp;</button>
                  </div>
                </span>

              </ng-container>



              <ng-container *ngIf="configurationDropDownList[0]
  ['recursuive'][0].configAttributeType==3;">
                <span class="mtb10">

                  <div class="size,mtb10" fxLayoutGap="5px">
                    <span class="fw-500"> {{configurationDropDownList[0]
                      ['recursuive'][0].key}}:</span>
                    <button [class.highlightedImage]="secondIndex ==j" fxLayoutGap="5px" mat-raised-button
                      (click)="getConfigProductIdButton(j,'secondIndex')" *ngFor="let size of configurationDropDownList[firstIndex]
      ['recursuive'];let j=index;">{{size.value}}</button>
                  </div>
                </span>

              </ng-container>
            </ng-container>
          </div>

        </ng-template>



        <div [ngStyle]="{'margin-top':!showNewConfig ? '10px' : '0px' }" fxLayout="column" fxLayoutGap="10px">


          <!-- <calsoft-size-chart [sizeId]="sizeChartId"></calsoft-size-chart> -->


          <div style="padding-top: 10px;" *ngIf="MapLink && MapLink?.length > 0">
            <div class="map-link-container pointer" fxLayout="row" fxLayoutAlign="space-between center">
              <a (click)="getDirections(MapLink)" class="map-link">
                {{Address}}
              </a>
              <div class="assured-badge">
                Assured
              </div>
            </div>
          </div>




          <mat-divider></mat-divider>


          <div *ngIf="data.disablePriceInDetailPage==0">

            <calsoft-price [specialPrice]="specialPrice" [data]="data" [product]="product" [price]="price"
              [discountPercentage]="discountPercentage" [units]="units">
            </calsoft-price>
          </div>


          <ng-container>
            <div style="display: flex; gap: 10px;">
              <div fxFlex="50" *ngIf="(qty>0 && isInStock==1)||(manageStock==0); else elseBlock">
                <button *ngIf="data.enableEnquire==1" fxFlex="100" (click)="generateWhatsAppMessage()"
                  class="primary styles__btn1 block" style="color:white;">
                  <img style="height: 24px; color: white;" [alt]="'Enquire About' + productName"
                    src="assets/icons/whatsapp.svg">
                  Enquire Now
                </button>
              </div>
              <ng-template #elseBlock>
                <div fxFlex="50">
                  <button fxFlex="100" (click)="initOutStockFunction()" class="styles__btn primary padding-10">
                    <span style="text-transform: uppercase;">
                      Notify Me
                    </span>
                    <span>Get alert if this available</span>
                  </button>
                </div>
                <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="2px">
                  <div fxLayout="row">
                    <b>Sold Out</b>
                  </div>
                  <div fxLayout="row" fxFlex>
                    <span>This item is currently Not Available</span>
                  </div>
                </div>
              </ng-template>
            </div>
          </ng-container>


          <div>
            Share with a friend :

            <div fxHide.gt-lg fxHide.lg>
              <div fxLayout="row">

                <calsoft-share-speed-dial></calsoft-share-speed-dial>
              </div>
            </div>
            <button fxHide.lt-lg [matMenuTriggerFor]="menu" mat-icon-button>

              <mat-icon>share</mat-icon>
            </button>

          </div>
          <div [innerHTML]="product.description"></div>

          <calsoft-review-rating [reviewDetail]="reviewDetail"></calsoft-review-rating>

          <calsoft-video [videoAvaliable]="videoAvaliable" [videourl]="videourl"></calsoft-video>


        </div>
      </div>

    </div>

  </div>


  <div class="nav">

    <div *ngIf="initNav">
      <nav id="navbar">
        <a (click)="scrollToSection('overview')" [ngClass]="{ 'active': currentSection === 'overview' }">Overview</a>
        <a (click)="scrollToSection('report')" [ngClass]="{ 'active': currentSection === 'report' }">Report</a>
        <a (click)="scrollToSection('finance')" [ngClass]="{ 'active': currentSection === 'finance' }">Finance</a>
      </nav>
    </div>



    <section *ngIf="customField1array" id="overview">
      <div>
        <h2 class="spec-table-header">Overview</h2>
        <div fxLayout="column" class="spec-table1">
          <div fxLayout="row wrap">
            <div *ngFor="let row of customField1 | keyvalue" fxFlex="33.3" class="spec-item" fxLayout="column"
              fxLayoutAlign="start start">
              <div class="spec-title">
                {{ row.key.replace('_', ' ') }}
              </div>
              <div class="spec-value">{{ row.value }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section id="report" *ngIf="customField2array">
      <h2 class="spec-table-header">Inspection Report</h2>

      <div fxLayout="row wrap" class="spec-table">
        <div *ngFor="let item of customField2 | keyvalue; let i = index" fxFlex="50">
          <div fxLayout="row" fxLayoutAlign="start center" class="spec-item">
            <div class="spec-value" fxFlex="60">{{ item.key.replace('_', ' ') }}</div>
            <div class="spec-logo2" fxFlex="20"><mat-icon>check_circle_outline</mat-icon></div>
          </div>
        </div>
      </div>



    </section>
    <section *ngIf="visibleSpecificationarray" id="finance">
      <h2 class="spec-table-header">Car Specificatoins</h2>

      <div fxLayout="row wrap" class="car-specification-table">
        <div *ngFor="let item of visibleSpecification | keyvalue; let i = index" fxFlex="33.33">
          <div fxLayout="row" fxLayoutAlign="start center" class="spec-item">
            <div class="spec-title" fxFlex="60">{{ item.key.replace('_', ' ') }}</div>
          </div>
          <div class="spec-item">
            <div class="spec-value" fxFlex="40">{{ item.value }}</div>
          </div>
        </div>

        <div fxLayout="row" fxLayoutAlign="end end" class="view-specs-button">
          <button mat-button color="primary" class="button-all" (click)="toggleSpecificationsPopup()">VIEW ALL
            SPECIFICATIONS</button>
        </div>
        <app-specifications-popup [showPopup]="showPopup" (closed)="popupClosed()"></app-specifications-popup>

      </div>
    </section>

    <section *ngIf="featureSpecificationarray" id="finance">
      <h2 class="spec-table-header">Top Features of this car</h2>
      <div class="spec-table" fxLayout="row" fxLayoutAlign="start start"
        style="overflow-x: hidden; position: relative;">
        <button mat-icon-button (click)="scrollLeft(specTableContainer)" class="slide-button-left">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <div #specTableContainer class="spec-table-container" style="flex-grow: 1; overflow-x: auto;">
          <div class="spec-table-content" fxLayout="row" style="display: flex;">
            <div *ngFor="let features of featureSpecification | keyvalue" fxFlex="0 0 33.3%" class="spec-column"
              fxLayout="column" fxLayoutGap="16px">
              <div fxLayout="row" fxLayoutAlign="center center">
                <h3 class="spec-title">{{ features.key.replace('_', ' ') }}</h3>
              </div>
              <div *ngFor="let item of features.value.split(',')" class="spec-item-features" fxLayout="row"
                fxLayoutAlign="space-between center" style="padding: 8px 0;">
                <div class="spec-detail" fxLayout="row" fxLayoutAlign="start center">
                  <mat-icon style="margin-right: 8px;">check_circle</mat-icon>
                  <span class="spec-value">{{item}}</span>
                </div>
                <button mat-icon-button (click)="showInfo(item)">
                  <mat-icon style="color: purple;">info</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
        <button mat-icon-button (click)="scrollRight(specTableContainer)" class="slide-button-right">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </section>


  </div>

  <div id="productDetails" class="linkPadding" *ngIf="relatedProductsList?.length > 0 ">

    <calsoft-product-carousel [data]="data" [heightMobile]="productImageHeightMob" [widthMobile]="productImageWidthMob"
      [height]="productImageHeight" [width]="productImageWidth" [imageType]="productImageType"
      [showConfigurableDropdown]="showConfigurableDropdown" [showCartIcon]="showCartIcon"
      [showCartIncremented]="showCartIncremented" [type]="'product'" [header]="relatedProductsText"
      [products]="relatedProductsList">
    </calsoft-product-carousel>
  </div>

  <div id="productDetails" class="linkPadding" *ngIf="upSellsProductsList?.length > 0 ">

    <calsoft-product-carousel [heightMobile]="productImageHeightMob" [widthMobile]="productImageWidthMob" [data]="data"
      [height]="productImageHeight" [width]="productImageWidth" [imageType]="productImageType"
      [showConfigurableDropdown]="showConfigurableDropdown" [showCartIcon]="showCartIcon"
      [showCartIncremented]="showCartIncremented" [type]="'product'" [header]="upSellProductsText"
      [products]="upSellsProductsList">
    </calsoft-product-carousel>
  </div>

  <div id="productDetails" class="linkPadding" *ngIf="crossSellsProductsList?.length > 0 ">

    <calsoft-product-carousel [heightMobile]="productImageHeightMob" [widthMobile]="productImageWidthMob" [data]="data"
      [height]="productImageHeight" [width]="productImageWidth" [imageType]="productImageType"
      [showConfigurableDropdown]="showConfigurableDropdown" [showCartIcon]="showCartIcon"
      [showCartIncremented]="showCartIncremented" [type]="'product'" [header]="crossSellProductsText"
      [products]="crossSellsProductsList">
    </calsoft-product-carousel>
  </div>

  <div id="productDetails" class="linkPadding" *ngIf="recentlyViewedProducts.length > 0 ">

    <calsoft-product-carousel [heightMobile]="productImageHeightMob" [widthMobile]="productImageWidthMob" [data]="data"
      [height]="productImageHeight" [width]="productImageWidth" [imageType]="productImageType"
      [showConfigurableDropdown]="showConfigurableDropdown" [showCartIcon]="showCartIcon"
      [showCartIncremented]="showCartIncremented" [type]="'product'" [urlNavigation]="false"
      [header]="recentlyViewedProductsText" [products]="recentlyViewedProducts">
    </calsoft-product-carousel>
  </div>


  <div [class.container]="data.layoutDisplayTypeInDetailpage != '1'" *ngIf="init">
    <div class="calsoft-vertical-navigation-content"
    calsoftScrollbar
    [calsoftScrollbarOptions]="{ suppressScrollX: true}"
    #navigationContent>
    <calsoft-layout [value]="3" [homePageData]="homePageBuilder" [type]="2"></calsoft-layout>
    </div>
  </div>


  <div class="padB60">

  </div>




  <mat-menu #menu="matMenu">
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
      <div class="padding-10" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
        <button (click)="copy()" class="shareIcon" mat-icon-button>
          <mat-icon style="color: gray">content_copy</mat-icon>
        </button>
        <button (click)="whatsapp()" mat-icon-button class="shareIcon">
          <!-- <mat-icon style="color: green">
                      whatsapp
                  </mat-icon> -->
          <img style="height: 24px;" src="assets/icons/whatsapp.svg" alt="whatsapp">
        </button>
        <!-- <button (click)="facebook()" mat-icon-button class="shareIcon">
                  <img style="height: 24px;" src="assets/logo/facebook.png" alt="facebook">

              </button> -->

      </div>
    </div>
  </mat-menu>
</div>


<ng-template #notify>

  <div class="index-head primary">
    <span>Notify Me</span>
  </div>

  <form [formGroup]="secondFormGroup">
    <div class="padding-10">

      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
        <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
          <mat-label>Name</mat-label>
          <input matInput formControlName="customerName" required>
          <mat-error *ngIf="secondFormGroup.controls.customerName.errors?.required">
            Please fill out this field.
          </mat-error>

        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
        <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" required>
          <mat-error *ngIf="secondFormGroup.controls.email.errors?.required">
            Please fill out this field.
          </mat-error>

        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
        <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
          <mat-label>Phone No</mat-label>
          <input numbersOnly [autocomplete]="'off'" trim="blur" matInput formControlName="phone" minlength="10"
            maxlength="10" required>
          <mat-error *ngFor="let validation of form_validation_messages.phone">
            <mat-error class="error-message"
              *ngIf="secondFormGroup.controls['phone'].hasError(validation.type) && (secondFormGroup.controls['phone'].dirty || secondFormGroup.controls['phone'].touched)">
              {{validation.message}}
            </mat-error>
          </mat-error>

        </mat-form-field>
      </div>
    </div>
  </form>
  <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
    <button mat-raised-button mat-dialog-close tabindex="-1">Cancel</button>
    <button [disabled]="textAccount !='OK'" (click)=" submitOutOfStockPopup()" mat-raised-button>
      {{textAccount}}
      <mat-icon *ngIf="textAccount !='OK' ">
        <mat-spinner color="primary" diameter="20">
        </mat-spinner>
      </mat-icon></button>
  </div>
</ng-template>
<footer *ngIf="data.disableCartInDetailPage==0" fxHide fxShow.lt-sm class="positionFix11 mat-elevation-z6 ">
  <calsoft-controls [data]="data" [coversionTrackingIdGa]="coversionTrackingIdGa" *ngIf="(qty!=0||manageStock==0)
  &&isInStock==1" [buttonArray]="buttonArray" [product]="configProductSelected"
    [productCustomOption]="productCustomOption" [productOption]="salesFlatQuoteItemOption" [configproduct]="product"
    [productName]="productName" [type]="'addtocart'" [type]="'addtocart'">
  </calsoft-controls>
</footer>